import { Button, Card, Link } from 'components/atoms';
import { CheckGreenIcon, ClockIcon, LockIcon } from 'components/icons';
import { createTransLinksComponents } from '../../utils/transLinksComponents';
import { Frame } from 'components/organisms';
import { frameConfig } from '../../AppConfig';
import { Modal } from 'components/molecules';
import { Trans, useTranslation } from 'react-i18next';
import { useStelo } from './useStelo';
import classes from 'classnames';
import layout from '../../scss/layout.module.scss';
import React from 'react';
import styles from './Stelo.module.scss';

export default function Stelo() {
  const { iframeUrl, isApprovedRoute, loading, onSubmit, onSubmitStelo } =
    useStelo();

  const { t } = useTranslation();

  const variantPrefixText = isApprovedRoute
    ? 'stelo:approved'
    : 'stelo:rejected';

  return (
    <>
      <Modal
        className={styles.modal}
        isOpen={Boolean(iframeUrl)}
        onClose={onSubmitStelo}
      >
        <iframe
          className={styles.iframe}
          title="Stelo"
          src={iframeUrl}
          width="100%"
        />
      </Modal>
      <Frame
        {...frameConfig}
        bodyWrapperClassName={classes(
          layout['width-lg'],
          layout['frame-x-compact'],
          styles.frame,
        )}
        hideEditButton
      >
        <div
          className={styles.notification}
          data-test="stelo-notification"
          data-testid="stelo-notification"
        >
          <ClockIcon
            data-test="stelo-notification-icon"
            data-testid="stelo-notification-icon"
          />
          <span
            data-test="stelo-notification-text"
            data-testid="stelo-notification-text"
          >
            {t('stelo:top_notif')}
          </span>
        </div>
        <Card className={styles.card} dataTest="stelo-card">
          <div
            className={styles.title}
            data-test="stelo-card-title"
            data-testid="stelo-card-title"
          >
            {t('stelo:title')}
          </div>
          <div
            className={styles.body}
            data-test="stelo-card-body"
            data-testid="stelo-card-body"
          >
            <div
              className={styles['body-point']}
              data-test="stelo-card-body-point1"
              data-testid="stelo-card-body-point1"
            >
              <CheckGreenIcon
                data-test="stelo-card-body-point1-icon"
                data-testid="stelo-card-body-point1-icon"
              />
              <div
                data-test="stelo-card-body-point1-text"
                data-testid="stelo-card-body-point1-text"
                dangerouslySetInnerHTML={{
                  __html: t(`${variantPrefixText}.bullet1`),
                }}
              ></div>
            </div>
            <div
              className={styles['body-point']}
              data-test="stelo-card-body-point2"
              data-testid="stelo-card-body-point2"
            >
              <CheckGreenIcon
                data-test="stelo-card-body-point2-icon"
                data-testid="stelo-card-body-point2-icon"
              />
              <div
                data-test="stelo-card-body-point2-text"
                data-testid="stelo-card-body-point2-text"
                className={styles.bullet2}
              >
                <Trans
                  i18nKey="stelo:bullet2"
                  components={createTransLinksComponents()}
                />
              </div>
            </div>
          </div>
          <Button
            leftIcon={<LockIcon />}
            dataTest="stelo-card-btn"
            onClick={onSubmit}
            loading={loading}
          >
            {t('stelo:submitBtn')}
          </Button>
          <div
            className={styles.footer}
            data-test="stelo-card-footer"
            data-testid="stelo-card-footer"
          >
            <Trans
              i18nKey="stelo:footer"
              components={createTransLinksComponents()}
            />
          </div>
          <Link onClick={onSubmitStelo} className={styles.thankyou}>
            {t('stelo:thankyou')}
          </Link>
        </Card>
      </Frame>
    </>
  );
}
